<template>
    <b-form-group>
        <template slot="label">
            <span>{{ $t('values.questionnaires') }}</span>
        </template>
        <multiselect
            :state="state"
            :selected="model"
            :options="options"
            :loading="isLoading"
            :multiple="multiple"
            :searchable="searchable"
            :hideSelectedOptions="hideSelectedOptions"
            :placeholder="$t('form.placeholder.select')"
            :noOptions="$t('values.withoutQuestionnairesAvailable')"
            @changeValue="onChange"
            @click="getQuestionnaires"
        />
    </b-form-group>
</template>
<script>
import { getQuestionnaires } from '@/views/values/api'
import { Multiselect, mapperToOptions } from '@/views/components/selects'
export default {
    components: {
        Multiselect,
    },
    props: {
        periodIds: {
            type: Array,
        },
        model: {
            type: Array | null,
            required: true,
        },
        evaluatedId: {
            type: [Number, String],
            required: false,
        },
        valuerId: {
            type: Number,
            required: false,
        },
        applyValuerScope: {
            type: Boolean,
            default: false,
        },
        applyEvaluatedScope: {
            type: Boolean,
            default: false,
        },
        applyPublicationPermissionScope: {
            type: Boolean,
            default: false,
        },
        defaultSelecteds: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        state: {
            default: null,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        queryScopes: {
            type: String,
            default: null,
        },
        hideSelectedOptions: {
            type: Boolean,
            default: true,
        },
        lazyLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [],
            isLoading: false,
            isLoaded: false,
        }
    },
    computed: {
        scopes() {
            const scopes = []

            if (this.applyValuerScope) {
                scopes.push('of_valuer')
            }

            if (this.applyEvaluatedScope) {
                scopes.push('of_evaluated')
            }

            if (this.applyPublicationPermissionScope) {
                scopes.push('with_publication_permission')
            }

            return scopes
        },
    },
    mounted() {
        if (!this.lazyLoading) {
            this.getQuestionnaires()
        }
    },
    methods: {
        onChange(value) {
            this.$emit('update:model', value)
            this.$emit('change', value)
        },
        getQuestionnaires() {
            if (this.isLoaded) {
                return
            }

            this.isLoading = true
            return getQuestionnaires({
                with: 'period',
                scopesNames: this.scopes,
                valuer_id: this.valuerId,
                evaluated_id: this.evaluatedId,
                scopes: this.queryScopes,
                filter: 'id;title;status;period_id',
                periods: this.periodIds,
            })
                .then((questionnaires) => {
                    this.options = mapperToOptions(questionnaires)
                    this.setCurrentQuestionnaires(questionnaires)
                })
                .finally(() => {
                    if (this.options.length == 0) {
                        this.$emit('without-options-available')
                    }

                    this.$emit('ready')
                    this.isLoaded = true
                    this.isLoading = false
                })
        },
        setCurrentQuestionnaires(questionnaires) {
            const currentQuestionnairesIds = questionnaires.reduce((acc, questionnaire) => {
                if (questionnaire.period.status === 'in_progress') {
                    acc.push(questionnaire.id)
                }
                return acc
            }, [])

            if (this.defaultSelecteds) {
                this.applyDefault(currentQuestionnairesIds)
            }
        },
        applyDefault(ids) {
            const defaultSelecteds = this.options.filter((i) => {
                return ids.includes(i.value)
            })

            if (defaultSelecteds.length > 0) {
                this.onChange(defaultSelecteds)
            }
        },
    },
}
</script>
